import Resources from '@/Resources.js';

export function useFiltersLabelMapper(resources) {
    const getLabel = (labelKey) => {
        if (labelKey === undefined || labelKey === null) return '';
        return resources && resources[labelKey] ? resources[labelKey] : labelKey;
    };

    const mapFilters = (filters) => {
        return filters.map((filter) => ({
            ...filter,
            displayName: getLabel(filter.label),
        }));
    };

    const getSortDisplayName = (sortType, sortEnum) => {
        if (!resources || !sortEnum || sortType === null) {
            return Resources.Search.SearchProjectSortTitle;
        }

        const labelKey = getLabel(sortEnum[sortType]);
        return resources[labelKey.displayName] || labelKey;
    };

    return {
        getLabel,
        mapFilters,
        getSortDisplayName,
    };
}
